import React, { useEffect } from "react";
import Sidebar from "../layout/Sidebar";
import Header from "../layout/Header";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { pageRoutes } from "../routes/pageRoutes";
import { fetchProfile } from "../redux/action/authAction";
import Loader from "../components/other/Loader";

const Profile = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const { isToggle } = useSelector((state) => state.authReducer);
  const { profile, isLoading, isToggle } = useSelector(
    (state) => state?.authReducer
  );

  useEffect(() => {
    dispatch(fetchProfile());
  }, []);

  if(isLoading){
    return <Loader/>
  }

  return (
    <>
      <main className={isToggle ? "ct_collapsed_sidebar" : ""}>
        <Sidebar />
        <div className="ct_right_content">
          <Header />
          <div className="ct_inner_dashbaord_main">
            <div className="ct_white_bg ct_mt_28">
              <div className="ct_px_46">
                <div className="d-flex align-items-center justify-content-between gap-2 mb-5 flex-wrap">
                  <h4 className="ct_fs_22 ct_ff_roboto ct_fw_600">
                    My Profile
                  </h4>
                  <div className="d-flex align-items-center gap-3 flex-wrap">
                    <a
                      href="javascript:void(0)"
                      onClick={() => navigate(pageRoutes?.editProfile)}
                      className="ct_orange_btn"
                    >
                      Edit Profile
                    </a>
                    <a
                      href="javascript:void(0)"
                      onClick={() => navigate(pageRoutes?.changePassword)}
                      className="ct_orange_btn"
                    >
                      Change Password
                    </a>
                  </div>
                </div>

                <form>
                  <div className="row">
                    <div className="col-lg-6 mx-auto">
                      <div className="ct_profile_img">
                        <img                       
                          src={profile?.profile_image ? profile?.profile_image :  "./user_profile.png"}
                          alt="NA"
                          className="ct_img_148"
                        />
                        <label for="ct_edit_profile">
                          <input
                            type="file "
                            id="ct_edit_profile"
                            className="d-none"
                          />
                          {/* <div className="ct_edit_profile_icon">
                                <i className="fa-solid fa-pen"></i>
                              </div> */}
                        </label>
                      </div>

                      <div className="form-group text-start mb-4">
                        <label
                          for=""
                          className="ct_ff_roboto mb-2 ct_fw_500 ct_purple_text"
                        >
                          Full Name
                        </label>
                        <input
                          type="text"
                          className="ct_input form-control  ct_input_h_52"
                          value={profile?.full_name}
                          disabled
                        />
                      </div>
                      <div className="form-group text-start mb-4">
                        <label
                          for=""
                          className="ct_ff_roboto mb-2 ct_fw_500 ct_purple_text"
                        >
                          Email
                        </label>
                        <input
                          type="email"
                          className="ct_input form-control  ct_input_h_52"
                          value={profile?.email}
                          disabled
                        />
                      </div>
                      {/* <div className="form-group text-start mb-4">
                        <label
                          for=""
                          className="ct_ff_roboto mb-2 ct_fw_500 ct_purple_text"
                        >
                          Password
                        </label>
                        <input
                          type="password"
                          className="ct_input form-control  ct_input_h_52"
                          value={profile?.show_password}
                          disabled
                        />
                      </div> */}
                    </div>
                  </div>
                  {/* <div className="text-center">
                                        <button className="ct_orange_btn px-5">Save</button>
                                    </div> */}
                </form>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Profile;
